<script>
import { ModalsContainer, $vfm } from 'vue-final-modal';

export default {
  props: ['target'],
  methods:{
    openModal(){
      $vfm.show({
        component: 'UnitModal',
        bind: {
          name: 'UnitModal',
          imgSrc: this.target.image_path,
        },
        on: {
          cancel(close) {
            close();
          },
        }
      });
    }
  }
}
</script>

<template>
  <img class="magnifier"
              src="@/images/img/magnifier.png"
              @click.stop.prepend="openModal" />
</template>

<style>
  img.magnifier {
    width: 50px !important;
    height: 50px;

    position: relative;
    top: -110px;
  }
</style>
